import { render } from "./BrandedTextElement.vue.js?vue&type=template&id=6a636332&scoped=true!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=template&id=6a636332&scoped=true"
import script from "./BrandedTextElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=script&lang=js"
export * from "./BrandedTextElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=script&lang=js"

import "./BrandedTextElement.vue.scss?vue&type=style&index=0&id=6a636332&lang=scss&scoped=true!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=style&index=0&id=6a636332&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a636332"],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/text-element/BrandedTextElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a636332"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a636332', __exports__)) {
    api.reload('6a636332', __exports__)
  }
  
  module.hot.accept("./BrandedTextElement.vue.js?vue&type=template&id=6a636332&scoped=true!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=template&id=6a636332&scoped=true", () => {
    api.rerender('6a636332', render)
  })

}


export default __exports__